export default __webpack_public_path__ + "static/media/connect.af678272.png";